module.exports = __webpack_public_path__ + "assets/pointing-right.6d21d14e.svg";